import { createCollection, localStorageCollectionOptions } from '@tanstack/react-db'
import type { User } from '~/shared/user/user.supabase.schema'

const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

type MinimalStorage = {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

type StorageEventApi = {
  addEventListener(type: 'storage', listener: (event: StorageEvent) => void): void
  removeEventListener(type: 'storage', listener: (event: StorageEvent) => void): void
}

const memoryStorage: MinimalStorage = (() => {
  const store: Record<string, string> = {}
  return {
    getItem(key) {
      return Object.prototype.hasOwnProperty.call(store, key) ? store[key] ?? null : null
    },
    setItem(key, value) {
      store[key] = value
    },
    removeItem(key) {
      delete store[key]
    },
  }
})()

const noopEventApi: StorageEventApi = {
  addEventListener: () => {},
  removeEventListener: () => {},
}

const storage: MinimalStorage = isBrowser ? (window.localStorage as unknown as MinimalStorage) : memoryStorage
const storageEventApi: StorageEventApi = isBrowser ? (window as unknown as StorageEventApi) : noopEventApi

export const userDetailsCollection = createCollection(
  localStorageCollectionOptions<User>({
    id: 'user-details',
    storageKey: 'userDetails',
    storage,
    storageEventApi,
    getKey: (user) => user.id,
    startSync: true,
    onInsert: async () => {
      // No-op: hydration/write-through to localStorage only.
    },
    onUpdate: async () => {
      // No-op: remote persistence is handled centrally in the auth store.
    },
    onDelete: async () => {
      // No-op: localStorage persistence is handled by the adapter.
    },
  }),
)
